import React from "react";
import { Link } from "react-router-dom";
import ImportantToKnow from "../components/ImportantToKnow";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

import { useLanguage } from "../context/LanguageContext";

const Sitemap = () => {
  const { languageId } = useLanguage();

  /*
   * ============================================================
   * MENU LABELS
   *
   * These should ideally come from your translation API.
   * The fallback English values keep the sitemap working.
   * ============================================================
   */

  const menuItems = {
    home: "Home",
    bookACar: "Book a Car",
    ourCars: "Our Cars",
    modifyReservation: "Modify Reservation",
    about: "About Us",
    faq: "FAQ",
    contact: "Contact",
    terms: "Terms & Conditions",
    sitemap: "Sitemap",
    rates: "Rates",
    offers: "Offers",
    policy: "Policy",
  };

  /*
   * ============================================================
   * SITEMAP LINKS
   * ============================================================
   */

  const sitemapLinks = [
    {
      title: "Booking",
      icon: "🚗",
      links: [
        {
          label: menuItems.home,
          path: "/",
        },
        {
          label: menuItems.bookACar,
          path: "/bookacar",
        },
        {
          label: menuItems.ourCars,
          path: "/ourcars",
        },
        {
          label: menuItems.modifyReservation,
          path: "/modifyreservation",
        },
      ],
    },

    {
      title: "Information",
      icon: "ℹ️",
      links: [
        {
          label: menuItems.rates,
          path: "/rates",
        },
        {
          label: menuItems.about,
          path: "/about",
        },
        {
          label: menuItems.offers,
          path: "/offer",
        },
        {
          label: menuItems.policy,
          path: "/policy",
        },
      ],
    },

    {
      title: "Help & Support",
      icon: "💬",
      links: [
        {
          label: menuItems.faq,
          path: "/faq",
        },
        {
          label: menuItems.terms,
          path: "/termsconditions",
        },
        {
          label: menuItems.contact,
          path: "/contact",
        },
        {
          label: menuItems.sitemap,
          path: "/sitemap",
        },
      ],
    },
  ];

  return (
    <div className="sitemap-page">

      {/* ======================================================
          HERO
      ====================================================== */}

      <section className="sitemap-hero">

        <div className="container">

          <div className="sitemap-hero-content">

            <span className="sitemap-eyebrow">
              WEBSITE NAVIGATION
            </span>

            <h1>
              {menuItems.sitemap}
            </h1>

            <div className="sitemap-title-line" />

            <p>
              Explore all the important sections of our
              website in one place.
            </p>

          </div>

        </div>

      </section>


      {/* ======================================================
          SITEMAP CONTENT
      ====================================================== */}

      <section className="sitemap-content">

        <div className="container">

          <div className="sitemap-grid">

            {sitemapLinks.map(
              (section, sectionIndex) => (

                <div
                  className="sitemap-card"
                  key={sectionIndex}
                >

                  {/* CARD HEADER */}

                  <div className="sitemap-card-header">

                    <div className="sitemap-card-icon">
                      {section.icon}
                    </div>

                    <h2>
                      {section.title}
                    </h2>

                  </div>


                  {/* LINKS */}

                  <div className="sitemap-links">

                    {section.links.map(
                      (item, index) => (

                        <Link
                          to={item.path}
                          className="sitemap-link"
                          key={index}
                        >

                          <span className="sitemap-link-arrow">
                            →
                          </span>

                          <span>
                            {item.label}
                          </span>

                        </Link>

                      )
                    )}

                  </div>

                </div>

              )
            )}

          </div>


          {/* ==================================================
              QUICK ACCESS
          ================================================== */}

          <div className="sitemap-bottom">

            <div className="sitemap-bottom-inner">

              <div>

                <span className="sitemap-bottom-label">
                  QUICK ACCESS
                </span>

                <h3>
                  Ready to book your car?
                </h3>

                <p>
                  Find the perfect car and start
                  your journey today.
                </p>

              </div>

              <Link
                to="/bookacar"
                className="sitemap-book-btn"
              >
                Book a Car
                <span>→</span>
              </Link>

            </div>

          </div>

        </div>

      </section>
 <ImportantToKnow />
    </div>
  );
};

export default Sitemap;